import axios from 'axios';
// 直接导入整个vant，避免类型问题
import Vant from 'vant';
import store from '@/store';
// 使用Vant.Toast，避免类型问题
const Toast = Vant.Toast;
// 设置默认选项
Toast.setDefaultOptions({ duration: 1500 });
const instance = axios.create({
    timeout: 1000 * 12,
    baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_SRC2 : process.env.VUE_APP_SRC2
});
// 初始化接口取消的调用方法数组
if (!window._axiosCancelArr) {
    window._axiosCancelArr = [];
}
instance.interceptors.request.use(function (config) {
    const storageStr = window.localStorage.getItem('userInfo');
    const vuexState = store.state.app.userInfo ? store.state.app.userInfo.TOKEN : '';
    // 缓存有取缓存token，没有取store的token
    const token = storageStr ? JSON.parse(storageStr).TOKEN : vuexState;
    if (!config.headers) {
        config.headers = {};
    }
    config.headers.token = token || '';
    if (process.env.VUE_APP_GRAY === '1') {
        // eslint-disable-next-line dot-notation, quotes
        config.headers["gray"] = process.env.VUE_APP_GRAY;
    }
    if (config.url && config.url.includes('user/phone')) {
        config.headers['Content-Type'] = 'application/form-data';
        // 修复：检查config.data是否为FormData类型
        if (config.headers) { // 先检查headers是否存在
            if (config.data instanceof FormData) {
                // 使用FormData的forEach方法
                // @ts-ignore: FormData forEach类型问题
                config.data.forEach((val, key) => {
                    if (key !== 'Referer') {
                        // 确保val是字符串类型
                        // @ts-ignore: config.headers可能为undefined
                        config.headers[key] = typeof val === 'string' ? val : String(val);
                    }
                });
            }
            else if (config.data && typeof config.data === 'object') {
                // 如果是普通对象，使用Object.entries遍历
                Object.entries(config.data).forEach(([key, val]) => {
                    if (key !== 'Referer') {
                        // 确保val是字符串类型
                        // @ts-ignore: config.headers可能为undefined
                        config.headers[key] = typeof val === 'string' ? val : String(val);
                    }
                });
            }
        }
    }
    // 取消请求
    config.cancelToken = new axios.CancelToken((cancel) => {
        window._axiosCancelArr.push({ cancel });
    });
    return config;
}, function (error) {
    return Promise.reject(error);
});
instance.interceptors.response.use((response) => {
    if (response.status === 200) {
        return Promise.resolve(response.data);
    }
    else {
        return Promise.reject(response);
    }
}, (error) => {
    // 取消接口不提示
    if (error.code === 'ERR_CANCELED' || error.code === 'ECONNABORTED') {
        return Promise.reject(error);
    }
    if (error.response) {
        if (error.response.status) {
            switch (error.response.status) {
                case 404:
                    // @ts-ignore: Vant Toast 类型问题
                    Toast({
                        message: '网络请求不存在',
                        duration: 1500,
                        forbidClick: true
                    });
                    break;
                default:
                    // @ts-ignore: Vant Toast 类型问题
                    Toast({
                        message: error.response.data?.message || '请求失败',
                        duration: 1500,
                        forbidClick: true
                    });
            }
            return Promise.reject(error.response);
        }
    }
    else {
        // 处理 error.response 为 undefined 的情况
        // Toast({
        //   message: '网络请求异常',
        //   duration: 1500,
        //   forbidClick: true
        // })
        return Promise.reject(error);
    }
});
export default instance;
